import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UNCLAIMED_API = 'https://oppiesfunc.azurewebsites.net/api/getUnclaimedShops?code=rbu-lOPVYYbzTewD10fFuQcstMJL4PDp1HEOxBXghFWmAzFuOYvCTQ==';
const ASSIGN_API = 'https://oppiesfunc.azurewebsites.net/api/assignShopOwner?code=jrraozeg6lJLQg1cjG0wt-SQ_4rU1vAh8-E2He6ic9PaAzFuthAu0Q==';

function PendingClaims() {
    const [shops, setShops] = useState([]);
    const [status, setStatus] = useState('');
    const [assignments, setAssignments] = useState({});

    useEffect(() => {
        axios.get(UNCLAIMED_API)
            .then(res => setShops(res.data))
            .catch(err => setStatus('Failed to load unclaimed shops.'));
    }, []);

    const handleInputChange = (shopId, email) => {
        setAssignments({ ...assignments, [shopId]: email });
    };

    const assignOwnership = async (shopId) => {
        const email = assignments[shopId];
        if (!email) {
            setStatus(`Please enter an email for ${shopId}`);
            return;
        }

        try {
            await axios.post(ASSIGN_API, { shopId, email });
            setShops(shops.filter(shop => shop.shopId !== shopId));
            setStatus(`Assigned ${shopId} to ${email}`);
        } catch (err) {
            console.error(err);
            setStatus(`Failed to assign ${shopId}`);
        }
    };

    return (
        <div style={styles.container}>
            <h2>Assign Ownership to Unclaimed Shops</h2>
            {status && <p>{status}</p>}

            {shops.map((shop) => (
                <div key={shop.shopId} style={styles.card}>
                    <p><strong>{shop.name}</strong> ({shop.shopId})</p>
                    <p>{shop.address}</p>
                    <input
                        type="email"
                        placeholder="Enter owner email"
                        style={styles.input}
                        value={assignments[shop.shopId] || ''}
                        onChange={(e) => handleInputChange(shop.shopId, e.target.value)}
                    />
                    <button
                        style={styles.button}
                        onClick={() => assignOwnership(shop.shopId)}
                    >
                        Assign Ownership
                    </button>
                </div>
            ))}
        </div>
    );
}

const styles = {
    container: { padding: 30, maxWidth: 700, margin: '30px auto' },
    card: {
        border: '1px solid #ccc',
        borderRadius: 8,
        padding: 15,
        marginBottom: 20,
        backgroundColor: '#fdfdfd',
    },
    input: {
        padding: '8px',
        width: '60%',
        marginRight: '10px',
        borderRadius: 6,
        border: '1px solid #aaa',
    },
    button: {
        padding: '8px 12px',
        borderRadius: 6,
        backgroundColor: '#bfa97c',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
    },
};

export default PendingClaims;
